import _Object$assign from "@babel/runtime-corejs3/core-js-stable/object/assign";
import _trimInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/trim";
import React from 'react';
import { forwardStatics } from '@douyinfe/semi-foundation/lib/es/utils/object';
import DatePicker from './datePicker';
import ConfigContext from '../configProvider/context';
import LocaleConsumer from '../locale/localeConsumer';
export default forwardStatics( /*#__PURE__*/React.forwardRef((props, ref) => {
  const propsObj = _Object$assign({}, props);

  const {
    type,
    format,
    rangeSeparator
  } = propsObj;

  if (typeof format === 'string' && format) {
    if (!/[Hhms]+/.test(format)) {
      if (type === 'dateTime') {
        propsObj.type = 'date';
      } else if (type === 'dateTimeRange') {
        propsObj.type = 'dateRange';
      }
    }
  } // Add spaces at both ends to prevent conflicts with characters in the date when separating


  if (rangeSeparator && typeof rangeSeparator === 'string') {
    propsObj.rangeSeparator = " ".concat(_trimInstanceProperty(rangeSeparator).call(rangeSeparator), " ");
  }

  return /*#__PURE__*/React.createElement(ConfigContext.Consumer, null, _ref => {
    let {
      timeZone
    } = _ref;
    return /*#__PURE__*/React.createElement(LocaleConsumer, {
      componentName: 'DatePicker'
    }, (locale, localeCode, dateFnsLocale) => /*#__PURE__*/React.createElement(DatePicker, _Object$assign({
      timeZone: timeZone,
      localeCode: localeCode,
      locale: locale,
      dateFnsLocale: dateFnsLocale
    }, propsObj, {
      ref: ref
    })));
  });
}), DatePicker);